export const API_URL = {
	GETWAY_API: process.env.REACT_APP_GETWAY_API,
	COMMON_GATEWAY_API: process.env.REACT_APP_COMMON_GATEWAY_API || "https://stage-api.carmudi.com.ph/",
};

export const REFINANCE_OPS_ROLE = parseInt(process.env.REACT_APP_REFINANCE_OPS_ROLE_ID, 10) || 21;
export const CHECKER_ROLE_ID = parseInt(process.env.REACT_APP_CHECKER_ROLE_ID, 10) || 22;
export const TELESALES_ROLE_ID = parseInt(process.env.REACT_APP_TELESALES_ROLE_ID, 10) || 25;
export const PH_REFINANCE_BUCKET_NAME = 'refinance_docs';
export const BTCBUSINESS_LINE = "BTC";
export const YMDFORMAT = "YYYY-MM-DD";
export const FORMAT_DDMMMYYY = 'DD MMM YYYY';

export const BTC_INTEREST_TYPE = [
	{ value: 'Cold', label: 'Cold' },
	{ value: 'Warm', label: 'Warm' },
	{ value: 'Hot', label: 'Hot' }
];

export const VEHICLE_TYPE = [
	{
		"value": "1",
		"label": "Car"
	},
	{
		"value": "3",
		"label": "Truck"
	}
];

export const BTC_STATUS = [
	{ value: 1, label: "Basic Info Filled" },
	{ value: 2, label: "Documents Uploaded" },
	{ value: 3, label: "Income Proof Uploaded" },
	{ value: 4, label: "Lost" }
];

export const BTC_STATUS_IDS = {
	LOST: 4,
	CONVERTED: 5
};

export const BTC_SUB_STATUS_IDS = {
	OTHER: 2
};

export const FILTER_KEY_CHIPS_VALUE = {
	search_text: "Search",
	status_id: "Status",
	from_date: "From Date",
	to_date: "To Date",
	vehicle_type: "Vehicle Type",
};

export const ORDERBY_LEAD_FIELDS = [
	{ value: 'id__ASC', label: 'Appl. ID ASC' },
	{ value: 'id__DESC', label: 'Appl. ID DESC' },
];

export const BTC_TABS = {
	all: "all",
	all_cases: "all_cases",
	hot_cases: "hot_cases",
	warm_cases: "warm_cases",
	cold_cases: "cold_cases",
	converted: "converted",
	lost: "lost",
};

export const STATUS_NAME_ID = {
	APPLICATION: 1,
	CREATED: 2,
	RECEIEVED: 3,
	SELECTED: 4,
	FILLED: 5,
	UPLOADED: 6,
	FINANCIER: 7,
	CREDIT_INVESTIGATION: 8,
	CI_SCHEDULED: 9,
	CI_REPORT_CHECK: 10,
	FINANCIER_APPROVAL: 11,
	LOAN_APPROVED: 12,
	CONTRACT_SIGNED: 13,
	DISBURSEMENT: 14,
	LOAN_DISBURSED: 15,
	PAYMENT_VERFICATION: 16,
	DEALER_INCENTIVE_PAID: 17,
	PAYMENT_RECEIVED_FROM_FINANCIER: 18,
	LOST: 19,
	REJECT_APPLICATION_PROCESS: 20,
	COMPUTATION_GENERATED: 21,
	ON_HOLD: 22,
	BAP_HIT_REJECTED: 23,
	REJECT_INCORRECT_DATA: 24,
	REJECT_JUNK_APPLICATION: 25,
	CASUAL_ENQUIRY: 26,
	CANCEL_CUSTOMER: 27,
	CANCEL_DEALER: 28,
	CUSTOMER_DENIED: 29,
	ORCR_REJECTED: 30,
	OTHER_LOST: 31,
	REJECTED: 32,
	CI_REPORT_REJECTED: 33,
	LOAN_APPROVAL_REJECTED: 34,
	CANCELED_BY_FINANCIER: 35,
	CHANGE_OF_UNIT: 36,
	CHANGE_OF_BORROWER: 37,
	CHANGE_OF_FINANCIER: 38,
	CHANGE_OF_DEALER: 39,
	COMPUTATION: 40,
	COMPUTATION_VERIFIED: 41,
	COMPUTATION_RESUBMIT: 42,
};

export const AFTER_VERIFICATION_STATUS = [STATUS_NAME_ID.COMPUTATION_VERIFIED, STATUS_NAME_ID.PAYMENT_VERFICATION, STATUS_NAME_ID.DEALER_INCENTIVE_PAID, STATUS_NAME_ID.PAYMENT_RECEIVED_FROM_FINANCIER]

export const APIV = 2;

export const REQUEST_RESPONSE_ENCRYPTION = {
	aes_algo: "aes-256-cbc",
	response_aes_key: "770A8A65DA156D24EE2A093277530142",
	public_key: "-----BEGIN PUBLIC KEY-----\nMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDG2koJfj4vF4UkiSl9vnmznE31\nMV7wslypRbwHEbN0KL4YtpH42euTfTEpD3RuyC3+QG4jHAmtyn+jxQJsZN8/Tq4L\n4N+tp83PZDQoazJDBVDtBCx5Rsyz9P0xemJkbfhbY4LRwQojDYLBlNRI4LHuBnnf\n1sL3PU9daSNQud+GBQIDAQAB\n-----END PUBLIC KEY-----\n",
};

